import { render } from "./ModalBox.vue?vue&type=template&id=21f099e0&scoped=true"
import script from "./ModalBox.vue?vue&type=script&lang=js"
export * from "./ModalBox.vue?vue&type=script&lang=js"

import "./ModalBox.vue?vue&type=style&index=0&id=21f099e0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f099e0"]])

export default __exports__